import type { ComponentProps, ReactNode } from 'react';
import { Alert } from '@ksyos/design-system';

type AlertComponentProps = ComponentProps<typeof Alert>;

interface AlertWithTitleAndDescriptionProps extends Omit<AlertComponentProps, 'children' | 'title'> {
    description?: string | ReactNode;
    title: string | ReactNode;
}

export function AlertWithTitleAndDescription({
    description,
    title,
    ...rest
}: Readonly<AlertWithTitleAndDescriptionProps>) {
    return (
        <Alert {...rest}>
            {title}
            {description && <Alert.Text>{description}</Alert.Text>}
        </Alert>
    );
}
